export default __webpack_public_path__ + "static/media/codesThumb.5c702045.png";